(ns dashboard.views.policy.view
  (:require ["react" :as react]
            [clojure.string :as str]
            [dashboard.common :refer [format-date]]
            [dashboard.components.breadcrumbs :refer [breadcrumbs]]
            [dashboard.components.confirm-delete-file-modal :refer [confirm-delete-file-modal]]
            [dashboard.components.file-upload.view :as file-upload-view]
            [dashboard.components.paginated-list.view :as paginated-list]
            [dashboard.components.search.search-box :as search-box]
            [dashboard.entity.analysis.db :as analysis.db]
            [dashboard.entity.organization.db :as org.db]
            [dashboard.services.document-list :as document-list]
            [dashboard.services.document-viewer :as document-viewer]
            [dashboard.services.documents :as documents]
            [dashboard.subs :as subs]
            [dashboard.ui :as ui]
            [dashboard.utils :as utils]
            [dashboard.views.policy.config :as config]
            [re-frame.core :as rf]))

(def controllers
  [{:start
    (fn [_]
      (rf/dispatch [::document-list/get])
      (org.db/fetch-organization)
      (analysis.db/get-structured-analyses false)
      (analysis.db/get-applied-analyses false)
      (analysis.db/get-structured-analysis-questions false))}])

(def column-config
  [{:label    "Created"
    :id       :created
    :sort-key :created
    :render   (fn [{:keys [created]}]
                (format-date created))
    :classes  ["is-narrow"]}
   {:label    "Filename"
    :id       :filename
    :sort-key :filename
    :render   (fn [{:keys [filename id]}]
                [:a {:href "#"
                     :on-click #(rf/dispatch [::document-viewer/fetch-file-preview-url filename id])
                     :title "Click to view the document"}
                 filename])}
   {:label   ""
    :id      :actions
    :key     (fn [row]
               (select-keys row [:id :filename]))
    :render  (fn [{:keys [id filename] :as row}]
               [:div.level-right
                (when (str/includes? (str/lower-case filename) ".pdf")
                 [:a.button.is-small.is-rounded.is-secondary.mr-3
                 {:title "Compare to this document"
                  :on-click #(rf/dispatch [::document-viewer/fetch-file-preview-url-for-diff filename id])}
                 [:span.icon>i.fas.fa-code-compare]])
                [:a.button.is-small.is-rounded.is-secondary
                 {:title "Download"
                  :href (str "/api/policies/files/" (js/encodeURIComponent filename))}
                 [:span.icon>i.fas.fa-download]]
                [:a.button.is-small.is-light.is-danger.is-rounded.ml-2
                 {:on-click (fn [_]
                              (rf/dispatch
                               [::ui/push-modal
                                {:ctx       row
                                 :component (confirm-delete-file-modal
                                             {:on-confirm
                                              (fn [_]
                                                (rf/dispatch [::documents/delete id filename]))})}]))
                  :title "Delete"}
                 [:span.icon>i.fas.fa-trash]]])
    :classes ["is-narrow"]}])

(def accepted-policy-formats ".docx, .pdf, .txt, .xlsx, .xlsm")

(defn upload-policy-modal [{:keys [ctx]}]
  (let [items @(rf/subscribe [::documents/data])]
    [file-upload-view/upload-modal {:title                 "Upload policies"
                                    :context               ctx
                                    :file-type             :policies
                                    :uploaded-files        items
                                    :accepted-file-formats accepted-policy-formats}]))

(rf/reg-sub
 ::document-rows
 :<- [::documents/data]
 (fn [documents]
   (->> documents
        (filter (comp not :is-obsolete))
        (map #(assoc % :paginated-list/row-key (:id %))))))

(rf/reg-sub
 ::obsolete-rows
 :<- [::documents/data]
 (fn [documents]
   (->> documents
        (filter :is-obsolete)
        (map #(assoc % :paginated-list/row-key (:id %))))))

(rf/reg-sub
 ::view-mode
 (fn [db _] (get-in db [:document-list :mode] :list)))

(rf/reg-event-db
 ::set-view-mode
 (fn [db [_ value]]
   (assoc-in db [:document-list :mode] value)))

(defn set-view-mode
  [value]
  (rf/dispatch [::set-view-mode value]))

(defn policies-page []
  (let [heading @(rf/subscribe [::subs/view.page-heading])
        mode @(rf/subscribe [::view-mode])
        [show-obsolete set-show-obsolete] (react/useState false)]
    [:div.document-list
     [breadcrumbs {:items (config/breadcrumbs)}]
     [:div.section
      [:div.level
       [:div.title.is-3.mt-0.mb-1.is-flex
        heading
        [:div.buttons.my-0.ml-5
         [:button.button
          {:class (if (= mode :list) :is-primary :is-secondary)
           :on-click #(set-view-mode :list)}
          "File List"]
         [:button.button
          {:class (if (= mode :search) :is-primary :is-secondary)
           :on-click #(set-view-mode :search)}
          "Search"]]]
       [:div.level
        [:input.mr-2
         {:type :checkbox
          :value show-obsolete
          :on-change #(set-show-obsolete not)}]
        [:div.is-size-6 "Obsolete Documents"]]]

      (when show-obsolete
        [:div.notification.is-warning.mt-0.py-1.mb-2
         [:h6.title.is-6
          [:i.icon.fas.fa-triangle-exclamation.mr-2]
          "Displaying Obsolete Documents"]])

      (if (= mode :search)
        [:f> search-box/search-panel
         (fn [& args] (rf/dispatch (into [::document-viewer/fetch-file-preview-url] args)))
         true
         nil
         true]
        [:f> paginated-list/paginated-list
         {:view-name      config/view-id
          :header-content [:a.button.is-primary.mx-3.is-rounded
                           {:title "Click here to upload a new document"
                            :on-click #(rf/dispatch [::ui/push-modal {:component #'upload-policy-modal}])} "Upload"]
          :columns        column-config
          :search-enabled true}
         {:items-sub (if show-obsolete
                       [::obsolete-rows]
                       [::document-rows])
          :loading-sub [::documents/loading]
          :default-sort-keyfn :created
          :default-sort-order :desc
          :data-filter (fn [search-query {:keys [filename]}]
                         (utils/match-search-query
                          search-query
                          (fn [search-query]
                            (utils/str-includes-icase? filename search-query))))}])]]))
